import { render, staticRenderFns } from "./MembershipTermsModal.vue?vue&type=template&id=bd1a0162&scoped=true"
import script from "./MembershipTermsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MembershipTermsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MembershipTermsModal.vue?vue&type=style&index=0&id=bd1a0162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1a0162",
  null
  
)

export default component.exports